import { isWithinInterval } from 'date-fns';

import { Row } from '../../../coaching-observation/experimental.grid';
import {
    CoverageDataDto,
    RosterType,
} from '../../coverage.coaching-insight.model';
import { ScheduleEventDto } from '../../schedule.coaching-insight.model';
import {
    CellContext,
    ColumnType,
    RosterItem,
    RowContext,
    TemplateID,
} from '../coaching-coverage-grid.model';
import { DateRange } from '../select-period-date-range.component';

export function makeRows(
    roster: RosterItem[],
    rosterType: RosterType,
    data: CoverageDataDto,
    periodDateRanges: DateRange[],
    scheduleEvents: ScheduleEventDto[],
    managerId: number, // null for root rows, set for child rows
    depth: number = 0,
): Array<Row<RowContext, CellContext>> {
    const height = 80;

    return roster
        .filter((e) => {
            if (rosterType === RosterType.TEAM && managerId == null) {
                return e.rosterTypeId === RosterType.SELF;
            }
            return e.rosterTypeId === rosterType && e.managerId === managerId;
        })
        .map((e) => {
            const templateId =
                e.rosterTypeId === RosterType.SELF
                    ? TemplateID.SELF
                    : TemplateID.TEAM;
            const overallDat = data.overall.find(
                (ee) => ee.userId === e.userId,
            );

            const row: Row<RowContext, CellContext> = {
                id: Math.random().toString(),
                height,
                cells: [
                    {
                        ctx: {
                            templateId: TemplateID.BOTH,
                            user: e,
                            overall: overallDat,
                        },
                        columnId: ColumnType.NAME.toString(),
                        height,
                    },
                    {
                        ctx: {
                            templateId: TemplateID.BOTH,
                            user: e,
                            overall: overallDat,
                        },
                        columnId: ColumnType.OA_SCORE.toString(),
                        height,
                    },
                    {
                        ctx: {
                            templateId: TemplateID.BOTH,
                            user: e,
                            overall: overallDat,
                        },
                        columnId:
                            ColumnType.OVERALL_COACHING_PERCENT.toString(),
                        height,
                    },
                ],
                ctx: { isExpanded: true, depth },
            };

            periodDateRanges.forEach((week, ii) => {
                const periodDat = data.periods.find(
                    (ee) =>
                        ee.userId === e.userId &&
                        ee.startDate.getTime() === week.startDate.getTime() &&
                        ee.endDate.getTime() === week.endDate.getTime(),
                );
                const schedule = scheduleEvents.filter((ee) => {
                    return (
                        ee.participants.findIndex(
                            (eee) => eee.userId === e.userId,
                        ) !== -1 &&
                        isWithinInterval(ee.eventDate, {
                            start: week.startDate,
                            end: week.endDate,
                        })
                    );
                });

                row.cells.push(
                    {
                        ctx: {
                            templateId: TemplateID.BOTH,
                            user: e,
                            overall: overallDat,
                            period: periodDat,
                            schedule,
                        },
                        columnId: `${ColumnType.COACHING_COVERAGE_PERCENT}-${ii}`,
                        height,
                    },
                    {
                        ctx: {
                            templateId,
                            user: e,
                            overall: overallDat,
                            period: periodDat,
                            schedule,
                        },
                        columnId: `${ColumnType.OBSERVATION_COVERAGE_PERCENT}-${ii}`,
                        height,
                    },
                    {
                        ctx: {
                            templateId,
                            user: e,
                            overall: overallDat,
                            period: periodDat,
                            schedule,
                        },
                        columnId: `${ColumnType.COMMITMENT_COVERAGE_PERCENT}-${ii}`,
                        height,
                    },
                );
            });

            const childRosterType =
                rosterType === RosterType.TEAM && managerId == null
                    ? RosterType.TEAM
                    : null;
            if (childRosterType != null) {
                row.children = makeRows(
                    roster,
                    childRosterType,
                    data,
                    periodDateRanges,
                    scheduleEvents,
                    e.userId,
                    depth + 1,
                );
            }

            return row;
        });
}
